export default __webpack_public_path__ + "static/media/white-logo-text.6af05042.png";